// extracted by mini-css-extract-plugin
export default {"formContainer":"details_formContainer__osqI9"};